export interface allResponse<T> {
  data: T;
  result: ResultAPI;
  metadata?: MetadataType;
}

export interface Dashboards {
  dashboards: Dashboard[],
}

export interface Dashboard {
  application: string;
  business_status: string;
  business_status_description: string;
  created_date: string;
  customer?: Customer;
  loan?: Loan;
  merchant_id: string;
  order?: Order,
  product: string;
  proposal?: Proposal;
}

export interface Customer {
  // Asteriscados por el backend
  document_id: string;
  email: string;
  last_name: string | null;
  name: string;
  phone: string;
}

export interface Loan {
  loan_id: string;
  created_date: string;
  fee: number;
  opening_fee: number;
  pending_refund_amount: number | string;
  pending_refund_client_taxes: number | string;
  pending_refund_type: number | string;
  principal_amount: number;
  refunds: number | string;
  requested_amount: number;
  tae: number;
  term: number;
  total_refunded: number;
}

export interface Proposal {
  commercial_offer_id: string;
  commercial_offer_name: string;
  credit_proposal_id: string;
  opening_fee: number;
  opening_fee_type: string;
  principal_amount: number;
  product_description: string;
  proposal_reference?: string;
  requested_amount: number;
  status: string;
  tae: number;
  term: number;
}

export interface Order {
  cart_id: string,
  order_id: string,
  process_type: string,
  status: string,
  total_price: number,
  total_products: number,
  total_refunded: number,
}

export interface Merchant {
  commercial_agent: CommercialAgent;
  commercial_name: string;
  good_types: GoodTypes[];
  legal_name: string;
  level: number;
  merchant_id: string;
  sales_type: string;
  sector: string;
  product: string;
}
export interface CommercialAgent {
  call_center_phone: string;
  email: string;
  name: string;
  surname: string;
  phones: string[];
}
export interface CommercialOffersApiResponse {
  flow_commercial_offers: FlowCommercialOffer[];
}
export interface FlowCommercialOffer {
  flow: FlowType;
  commercial_offers: CommercialOffer[];
}
export interface CommercialOffer {
  commercial_offer_id: string;
  max_amount: number;
  min_amount: number;
  opening_fee_fix_amount: number;
  opening_fee_percentage: number;
  opening_fee_type: string;
  product_type: string;
  term: number;
  term_deferred: number;
  tin: number;
  is_preferred: boolean;
}

export interface CommercialOfferSimulations {
  max_amount: number;
  min_amount: number;
  term: number;
}

export interface GoodTypes {
  code: string;
  name: string;
  restrictions: string;
}

export enum FlowType {
  ECO = 'ECO',
  CEX = 'CEX',
  CBR = 'CBR',
  SUS = 'SUS',
  PLS = 'PLS',
}

interface ResultAPI {
  status: number;
  http_code: HttpCodes;
  info: string;
  errors: any;
}
type HttpCodes = 200 | 201 | 202 | 204 | 400 | 401 | 403 | 404 | 500 | 503;

export interface OrderSortType {
  sort: SortType;
  order: OrderType;
}

export enum SortType {
  DESC = 'DESC',
  ASC = 'ASC',
}

export enum OrderType {
  CUSTOMER = 'CUSTOMER',
  STATUS = 'STATUS',
  CARTID = 'CARTID',
  DATE = 'DATE',
  AMOUNT = 'AMOUNT',
}

interface MetadataType {
  paging: {
    limit: number,
    offset: number,
    more_items: boolean
  }
}

export enum CancelReason {
  IPL = 'IPL', // Incumple política
  ACL = 'ACL', // Anulación cliente
  AIN = 'AIN', // Anulación intermediario
}
